import { signupPageObject } from "@commons/utils/pageObjects/signup.pageObject"
import { clarity } from "./clarityInitializer"

export const signupEventsMap = (): Map<HTMLElement | null, () => void> => {
    const existentClarity = clarity
    if (!existentClarity) {
        return new Map<HTMLElement | null, () => void>([])
    }

    const pageObject = signupPageObject()

    return new Map([
        [
            pageObject.appleSignupButton,
            () => {
                existentClarity.setCustomEvent("appleSignupClick")
            }
        ],
        [
            pageObject.googleSignupButton,
            () => {
                existentClarity.setCustomEvent("googleSignupClick")
            }
        ],
        [
            pageObject.submitButton,
            () => {
                existentClarity.setCustomEvent("submitSignupClick")
            }
        ],
        [
            pageObject.agreeCheckbox,
            () => {
                existentClarity.setCustomEvent("agreeCheckboxClick")
            }
        ],
        [
            pageObject.alreadyHaveAccount,
            () => {
                existentClarity.setCustomEvent("alreadyHaveAccountClick")
            }
        ],
        [
            pageObject.signupCodeSubmit,
            () => {
                existentClarity.setCustomEvent("signupCodeSubmitClick")
            }
        ],
        [
            pageObject.resendCode,
            () => {
                existentClarity.setCustomEvent("resendSignupCodeClick")
            }
        ],
        [
            pageObject.backSignupCode,
            () => {
                existentClarity.setCustomEvent("backSignupCodeClick")
            }
        ]
    ])
}
